import { Button, Col, Result, Row } from "antd";
import { Link } from "react-router-dom";

export default function Error() {
  return (
    <Row
      align={"middle"}
      justify={"center"}
      style={{ minHeight: "80vh" }}
    >
      <Col>
        <Result
          status="500"
          title="Something went wrong"
          subTitle="Sorry, something went wrong on our side. If the problem persists, please let us know via info@root-sustainability.com. Thank you!"
          extra={
            <Link to={"/"}>
              <Button type="primary">Go home</Button>
            </Link>
          }
        />
      </Col>
    </Row>
  );
}
